import { Dispatch } from 'redux';

import { apiFetchVolopFunctions } from 'api/apiVolopFunction';
import { ApiVolopFunction } from 'api/types/ApiVolopFunction';

import { setError } from './error';

// Types

export type MainStoreVolopFunctionsState =
  | ApiVolopFunction[]
  | null
  | undefined;

export type MainStoreVolopFunctionsAction = {
  type: 'VOLOP_FUNCTIONS_SET';
  volopFunctions: ApiVolopFunction[] | null | undefined;
};

// Reducer

export function volopFunctionsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreVolopFunctionsState = null,
  action: MainStoreVolopFunctionsAction,
) {
  switch (action.type) {
    case 'VOLOP_FUNCTIONS_SET': {
      return action.volopFunctions;
    }

    default:
      return state;
  }
}

// Actions

export const fetchVolopFunctions =
  () =>
  (
    dispatch: Dispatch<MainStoreVolopFunctionsAction>,
    getState: () => { volopFunctions: MainStoreVolopFunctionsState },
  ) => {
    if (getState().volopFunctions) {
      return;
    }

    apiFetchVolopFunctions()
      .then((volopFunctions) => {
        dispatch({
          type: 'VOLOP_FUNCTIONS_SET',
          volopFunctions,
        });
      })
      .catch(setError);
  };
